import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { SegmentPageActionTypes, SegmentUiElements } from '@foxcorp/delta-web-analytics';

const PosterCTA = ({ linkText, segmentPlaylistButtonAction, theme, url }) => (
  <Link
    onClick={() => {
      segmentPlaylistButtonAction({
        actionType: SegmentPageActionTypes.MORE_EPISODES,
        uiElement: SegmentUiElements.MORE_EPISODES,
      });
    }}
    to={url}
  >
    <button className={theme.posterCTA}>{linkText}</button>
  </Link>
);

PosterCTA.propTypes = {
  linkText: PropTypes.string,
  segmentPlaylistButtonAction: PropTypes.func,
  theme: PropTypes.shape({}),
  url: PropTypes.string,
};

PosterCTA.defaultProps = {
  linkText: '',
  segmentPlaylistButtonAction: () => {},
  theme: {},
  url: null,
};

export default PosterCTA;
